/**
 * Dónde vive la pantalla "Configuración de revisión y optimización" y cómo se
 * elige su pestaña.
 *
 * Es un archivo aparte, sin imports, para que lo usen tanto la pantalla como
 * los componentes que viven dentro de ella (la Activación enlaza a la
 * Calibración) sin crear un ciclo de dependencias entre ellos.
 */

/** La ruta de la pantalla, absoluta. */
export const RUTA_CONFIGURACION_REVISION_OPTIMIZACION = '/administracion/revision-y-optimizacion';

/** El query param que elige la pestaña: `?tab=activacion` | `?tab=calibracion`. */
export const PARAM_PESTANA = 'tab';

export type PestanaConfiguracion = 'activacion' | 'calibracion';

/** Las pestañas, en el orden en que se muestran. */
export const PESTANAS_CONFIGURACION: readonly {
    id: PestanaConfiguracion;
    etiqueta: string;
}[] = [
    { id: 'activacion', etiqueta: 'Activación por sucursal' },
    { id: 'calibracion', etiqueta: 'Calibración' },
];

/** El valor del query param si es una pestaña que existe; `null` si falta o es otra cosa. */
export function pestanaDelParam(valor: string | null | undefined): PestanaConfiguracion | null {
    const pestana = PESTANAS_CONFIGURACION.find((p) => p.id === valor);

    return pestana ? pestana.id : null;
}

/**
 * La pestaña que se muestra. Si la URL no elige una válida, un admin arranca en
 * la Activación y cualquier otro en la Calibración: la Activación sólo se puede
 * ver con rol admin, y abrirle la pantalla en una pestaña que le dice que no
 * puede no le sirve a nadie.
 */
export function pestanaActiva(
    valor: string | null | undefined,
    esAdmin: boolean
): PestanaConfiguracion {
    return pestanaDelParam(valor) ?? (esAdmin ? 'activacion' : 'calibracion');
}
